import { type CollectionChainType } from '../common/structs/daas/v2/common';
export const collection = () => ({
    chainData: (chain: CollectionChainType) => ({
        details: `/chain/${chain}/collections/details`,
        tokens: `/chain/${chain}/collections/tokens`,
    }),
    metadata: `/collections`,
    totalListings: `/listings/total`,
    totalSales: `/sales/total`,
    totalSalesVolumeInDays: (slug: string) => `/sales/${slug}/volume_n_days`,
    totalOwners: (slug: string) => `/collections/${slug}/owners/count`,
});
